import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dreamy%20anime%20style%20illustration%20of%20two%20figures%20standing%20in%20a%20field%20of%20soft%20cream%20colored%20flowers%20under%20a%20warm%20golden%20sunset%2C%20floating%20petals%20dancing%20in%20gentle%20breeze%2C%20ethereal%20atmosphere%20with%20soft%20focus%20edges%2C%20warm%20rose%20and%20peach%20tones%2C%20cinematic%20composition%2C%20emotional%20and%20nostalgic%20mood%2C%20artistic%20illustration%20not%20photorealistic&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
        alt="乳色吐息动漫 官方正版资源与剧情解析"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          乳色吐息
        </h1>
        <p className="text-base md:text-xl text-white/80 mb-3 max-w-2xl mx-auto leading-relaxed">
          官方正版资源与剧情解析
        </p>
        <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto mb-8 leading-relaxed">
          深入解析乳色吐息动漫的故事背景、人物关系与艺术风格，为粉丝提供最全面的内容导览与资源推荐
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/plot-analysis"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索剧情解析
          </Link>
          <Link
            to="/category/viewing-guide"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            观看指南
          </Link>
        </div>
      </div>
    </section>
  );
}